/* global jQuery COMPONENTS */

COMPONENTS.ComponentSpecials = (function ($) {
  function ComponentSpecials () {
    this.$component = $('[data-ecs-component="component-specials"]')
    this.$anchors = $('a')
    this.$specialsOnLoad = $('[data-ecs-specials-on-load]')
  }

  ComponentSpecials.prototype.init = function () {
    const component = this
    component.$anchors.each(function () {
      // Set a scoped reference to the anchor and href
      const $anchor = $(this)
      // If it doesn't have an href make sure to pass along an empty string
      // to the rest of the functiob below to prevent undefined errors
      const href = ($anchor.attr('href') ? $anchor.attr('href') : '')

      // Handle fancybox inline content
      if (href.includes('#components-specials')) {
        const link = href
        $anchor.attr('data-fancybox', '')
        $anchor.attr('data-src', link)
        $anchor.attr('href', 'javascript:;')
      }
    })

    if (component.$specialsOnLoad.length > 0) {
      // Function to open specials popup
      const openSpecials = function () {
        component.$specialsOnLoad.each(function () {
          const $specialsComponent = $(this)
          $.fancybox.open({
            src: '#' + $specialsComponent.attr('id'),
            type: 'inline'
          })
        })
      }

      // Wait for window load to ensure Fancybox is fully loaded
      if (document.readyState === 'complete' && typeof $.fancybox !== 'undefined') {
        openSpecials()
      } else {
        $(window).on('load', function () {
          openSpecials()
        })
      }
    }
  }

  return ComponentSpecials
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Hook into the main components init
  COMPONENTS.componentSpecials = new COMPONENTS.ComponentSpecials()
  COMPONENTS.componentSpecials.init()
})
